import { Box, Typography } from '@mui/material';

export type PleaseSelectDealerPlaceholderProps = {
  /** Defaults to the same copy used across Email grids and Run Logs. */
  message?: string;
  minHeight?: number;
};

/**
 * Centered empty state when the header has no dealership selected.
 */
export default function PleaseSelectDealerPlaceholder({
  message = 'Please select a dealer',
  minHeight = 240,
}: PleaseSelectDealerPlaceholderProps) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1200,
        mx: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight,
      }}
    >
      <Typography variant="h5" color="text.secondary" fontWeight={400}>
        {message}
      </Typography>
    </Box>
  );
}
